export class Stream {
    id: string;
    name: string;
    description: string;
    owner: string;
    read_only: boolean;
    parent: string;
    children: Stream[];
    inclusive: boolean;
    created: Date;
    include_slack: boolean;
    members: any[];
    private: boolean;
}
